import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { getInjuryTypes } from "../api/analytics/apiAnalytics";

export const ALL_INJURY_TYPES_OPTION = {
  label: "All Injury Types",
  value: "all_injury_types",
};

const useInjuryTypes = () => {
  const {
    isLoading: injuryTypesLoading,
    isError,
    data: injuryTypesData,
  } = useQuery(["injuryTypes"], () => getInjuryTypes(), {
    keepPreviousData: true,
  });

  const isLoadingOrError = injuryTypesLoading || isError;

  const injuryTypeOptions = useMemo(() => {
    if (isLoadingOrError) {
      return [ALL_INJURY_TYPES_OPTION];
    }

    const rawData = injuryTypesData?.data?.data;
    if (!rawData || !Array.isArray(rawData)) {
      return [ALL_INJURY_TYPES_OPTION];
    }

    // Normalize different backend shapes to {label, value}
    const normalized = rawData
      .map((item: any) => {
        if (typeof item === "string") {
          return { label: item, value: item };
        }
        if (item && item.label && item.value) {
          return { label: item.label, value: item.value };
        }
        if (item && item.name) {
          return { label: item.name, value: item.name };
        }
        if (item && item.Name) {
          return { label: item.Name, value: item.Name };
        }
        return null;
      })
      .filter(Boolean);

    // Deduplicate by value
    const unique = Array.from(
      new Map(normalized.map((option: any) => [option.value, option])).values()
    );

    return [ALL_INJURY_TYPES_OPTION, ...unique];
  }, [injuryTypesData, isLoadingOrError]);

  return {
    injuryTypeOptions,
    injuryTypesLoading,
    isError,
  };
};

export default useInjuryTypes;
